// src/utils/polyline.js
export function encodePolyline(coordinates, maxHacc = 0) {
	let result = ''
	let prevLat = 0
	let prevLng = 0

	coordinates.forEach((point) => {
		if (point.hacc && maxHacc > 0 && point.hacc > maxHacc) {
			return
		}

		let lat = Math.round(point.latitude * 1e5)
		let lng = Math.round(point.longitude * 1e5)

		let dLat = lat - prevLat
		let dLng = lng - prevLng

		prevLat = lat
		prevLng = lng

		result += encodeCoordinate(dLat) + encodeCoordinate(dLng)
	})

	return result
}

export function decodePolyline(encoded) {
	let index = 0
	let lat = 0
	let lng = 0
	const coordinates = []

	while (index < encoded.length) {
		let result = decodeCoordinate(encoded, index)
		lat += result.value
		index = result.index

		result = decodeCoordinate(encoded, index)
		lng += result.value
		index = result.index

		coordinates.push({
			latitude: lat * 1e-5,
			longitude: lng * 1e-5,
			hacc: 1,
		})
	}

	return coordinates
}

function encodeCoordinate(coord) {
	let coordBinary = coord < 0 ? ~(coord << 1) : coord << 1
	let output = ''

	while (coordBinary >= 0x20) {
		output += String.fromCharCode((0x20 | (coordBinary & 0x1f)) + 63)
		coordBinary >>= 5
	}

	output += String.fromCharCode(coordBinary + 63)
	return output
}

function decodeCoordinate(encoded, index) {
	let shift = 0
	let result = 0
	let byte = null

	do {
		byte = encoded.charCodeAt(index++) - 63
		result |= (byte & 0x1f) << shift
		shift += 5
	} while (byte >= 0x20)

	return {
		value: result & 1 ? ~(result >> 1) : result >> 1,
		index: index,
	}
}
